<template>
  <v-card class="mx-2 px-5 pt-4 pb-3 mb-2" style="border-radius: 8px">
    <!-- Select library -->
    <div
      class="inputPopupSelectDiv"
      @click="inputPopupSelectBranch.show = true"
    >
      <span class="label">Library</span>
      <v-text-field :value="inputPopupSelectBranch.selectedItem.name" readonly>
        <v-icon slot="prepend-inner">mdi-library</v-icon>
      </v-text-field>

      <InputPopupSelect
        title="Library"
        :list="visitBranchMenus"
        :select.sync="inputPopupSelectBranch"
      />
    </div>

    <!-- Select pax -->
    <div @click="inputPopupSelectPax.show = true" class="inputPopupSelectDiv">
      <span class="label">Pax</span>
      <v-text-field
        prepend-inner-icon="mdi-account-multiple"
        :value="inputPopupSelectPax.selectedItem.name"
        readonly
      >
      </v-text-field>

      <InputPopupSelect
        title="Pax"
        maxWidth="240px"
        :list="paxList"
        :select.sync="inputPopupSelectPax"
      />
    </div>

    <!-- Select date -->
    <div @click="inputPopupSelectDate.show = true" class="inputPopupSelectDiv">
      <span class="label">Date</span>
      <v-text-field
        prepend-inner-icon="mdi-calendar-month"
        :value="formatDate(inputPopupSelectDate.selectedItem)"
        readonly
      ></v-text-field>

      <InputPopupSelectDate
        :select.sync="inputPopupSelectDate"
        :allowed-dates="calendarAllowedDates"
        :min="calendar.min"
        :max="calendar.max"
      />
    </div>

    <v-row no-gutters>
      <!-- Select time -->
      <v-col
        @click="inputPopupSelectTime.show = true"
        class="inputPopupSelectDiv"
      >
        <span class="label">Time</span>
        <v-text-field
          prepend-inner-icon="mdi-clock-outline"
          :value="inputPopupSelectTime.selectedItem.name"
          readonly
        ></v-text-field>

        <InputPopupSelect
          title="Time"
          maxWidth="270px"
          :list="timeList"
          :select.sync="inputPopupSelectTime"
        />
      </v-col>

      <!-- Select duration -->
      <v-col
        @click="inputPopupSelectDuration.show = true"
        class="inputPopupSelectDiv"
      >
        <span class="label text-truncate">Duration (Hour : Min)</span>
        <v-text-field
          prepend-inner-icon="mdi-timer-sand"
          :value="inputPopupSelectDuration.selectedItem.name"
          readonly
        ></v-text-field>

        <InputPopupSelect
          title="Duration (Hour : Min)"
          maxWidth="270px"
          :list="durationList"
          :select.sync="inputPopupSelectDuration"
        />
      </v-col>
    </v-row>

    <!-- Buttons -->
    <div class="button-group" style="margin-top: 18px; margin-bottom: 18px">
      <v-row>
        <v-col>
          <v-btn @click="reset" dark color="primary" class="px-5" large block>
            <v-icon left dark>mdi-cached</v-icon>Reset
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-btn
            dark
            color="orange darken-2x"
            large
            class
            block
            @click="search"
          >
            <v-icon left dark>mdi-magnify</v-icon>Check available slots
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import moment from "moment";
import InputPopupSelect from "@/components/InputPopupSelect";
import InputPopupSelectDate from "@/components/InputPopupSelectDate";
import formatters from "@/helpers/formatters";
import calculator from "@/helpers/calculator";
import apiHelper from "@/helpers/apiHelper";
import businessLogic from "@/helpers/businessLogic";
import validators from "@/helpers/validators";

export default {
  name: "VisitBookingSearchForm",
  components: {
    InputPopupSelect,
    InputPopupSelectDate,
  },
  data: () => ({
    showSeatBookingSearchForm: false,
    inputPopupSelectBranch: {
      show: false,
      selectedItem: {
        //PublicBranchMenu
        name: null,
        code: null,
      },
    },
    inputPopupSelectPax: {
      show: false,
      selectedItem: {
        name: null,
        code: null, //0, 1
      },
    },
    inputPopupSelectDate: {
      show: false,
      selectedItem: null, //yyyy-MM-dd
    },
    inputPopupSelectTime: {
      show: false,
      selectedItem: {
        name: null,
        code: null, //HH-mm
      },
    },
    inputPopupSelectDuration: {
      show: false,
      selectedItem: {
        name: null, //(Hour:Minute)
        code: null, //Minutes
      },
    },
  }),
  computed: {
    ...mapGetters(["mode", "visitBranchMenus"]),
    selectedBranch() {
      return this.inputPopupSelectBranch.selectedItem;
    },
    selectedPax() {
      return this.inputPopupSelectPax.selectedItem;
    },
    selectedDate() {
      return this.inputPopupSelectDate.selectedItem;
    },
    selectedTime() {
      return this.inputPopupSelectTime.selectedItem;
    },
    selectedDuration() {
      return this.inputPopupSelectDuration.selectedItem;
    },
    paxList() {
      return calculator.paxList(this.selectedBranch.visitBookingMaxPax);
    },
    calendar() {
      const selectedBranch = this.selectedBranch;

      const dwellMinutesOfTheDay = businessLogic.getDwellTimeMinutes(
        this.settings.holidays,
        selectedBranch.dwellTime,
        this.time.todayMoment
      );

      const timeslotsAndDurations =
        calculator.getVisitBookingTimeslotsAndDurations(
          selectedBranch.openingHours,
          selectedBranch.visitBookingTimeIntervalInMinutes,
          selectedBranch.visitBookingDurationInMinutes,
          dwellMinutesOfTheDay,
          this.time.todayMoment
        );

      const calendar = calculator.visitBookingCalendar(
        timeslotsAndDurations,
        this.settings.system.advanceBookingDays,
        this.settings.system.bookingReleaseTime,
        selectedBranch.openingDaysOfWeek,
        this.settings.holidays,
        selectedBranch.code,
        this.time
      );

      return calendar;
    },
    timeList() {
      //Visit booking time list depends on the selected branch and the selected calendar date.
      //E.g. If the selected calendar date is today, passed timeslots shouldn't be shown
      const selectedBranch = this.selectedBranch;
      const isSameDate = this.time.nowMoment.isSame(
        moment(this.selectedDate),
        "day"
      );

      const timeList = calculator.visitBookingTimeList(
        selectedBranch.openingHours,
        selectedBranch.visitBookingTimeIntervalInMinutes,
        isSameDate,
        this.time.nowMoment,
        this.time.todayMoment
      );

      return timeList;
    },
    durationList() {
      //Visit booking duration list depends on branch, selected date (Dwell time can be different for different dates) and selected time
      const selectedBranch = this.selectedBranch;
      const selectedDateMoment = moment(this.selectedDate);
      const selectedTimeMoment = moment(this.selectedTime.code, "HH:mm");

      const dwellMinutesOfTheDay = businessLogic.getDwellTimeMinutes(
        this.settings.holidays,
        selectedBranch.dwellTime,
        selectedDateMoment
      );

      const timeslotsAndDurations =
        calculator.getVisitBookingTimeslotsAndDurations(
          selectedBranch.openingHours,
          selectedBranch.visitBookingTimeIntervalInMinutes,
          selectedBranch.visitBookingDurationInMinutes,
          dwellMinutesOfTheDay,
          selectedDateMoment
        );

      const durationList = calculator.visitBookingDurationList(
        timeslotsAndDurations,
        selectedTimeMoment
      );

      return durationList;
    },
  },
  methods: {
    ...mapMutations(["updateVisitBookingSearchResult"]),
    calendarAllowedDates(dateString) {
      if (!this.selectedBranch) {
        return false;
      }

      const isBranchOpenToday = validators.isBranchOpenToday(
        dateString,
        this.selectedBranch.openingDaysOfWeek,
        this.settings.holidays,
        this.selectedBranch.code
      );

      return isBranchOpenToday;
    },
    reset() {
      //Reset branch
      if (this.onsiteMode) {
        const branch = this.visitBranchMenus.find(
          (x) => x.id === this.mode.branchId
        );

        if (branch) {
          this.inputPopupSelectBranch.selectedItem = branch;
        }
      }

      //Reset pax
      this.inputPopupSelectPax.selectedItem = this.paxList[0];

      //Reset date, time, duration
      if (this.calendar && this.calendar.min) {
        this.inputPopupSelectDate.selectedItem = this.calendar.min;

        if (this.timeList) {
          this.inputPopupSelectTime.selectedItem = this.timeList[0];

          if (this.durationList) {
            this.inputPopupSelectDuration.selectedItem = this.durationList[0];
          }
        }
      }
    },
    async search() {
      const isOnOpeningDaysOfWeek = validators.isOnOpeningDaysOfWeek(
        this.selectedDate,
        this.selectedBranch.openingDaysOfWeek
      );

      const isHoliday = validators.isHoliday(
        this.selectedDate,
        this.settings.holidays,
        this.selectedBranch.code
      );

      if (!isOnOpeningDaysOfWeek || isHoliday) {
        this.updateResult({
          show: true,
          success: false,
          title: !isOnOpeningDaysOfWeek
            ? window.$msg.noVisitBookingOnWeekdays
            : window.$msg.noVisitBookingOpen,
        });

        return;
      }

      const branchId = this.selectedBranch.id;
      const pax = this.selectedPax.code;
      const starTime = this.selectedDate + "T" + this.selectedTime.code;
      const durationInMinutes = this.selectedDuration.code;

      const searchResponse = await apiHelper.searchAvailableVisitCapacity(
        branchId,
        pax,
        starTime,
        durationInMinutes
      );

      //commonResponseHandler is not used in this case, because this handler is a bit different
      //IM8 logout takes the highest priority
      if (searchResponse === window.$msg.reloginRequired) {
        businessLogic.im8Logout();

        return;
      }

      if (searchResponse && searchResponse.data) {
        if (searchResponse.data.visitCapacity) {
          //Add selected pax into the result for subsequent visit booking
          searchResponse.data.visitCapacity.pax = pax;
          this.updateVisitBookingSearchResult(searchResponse.data);

          if (searchResponse.data.found) {
            // this.$router.push({
            //   name: "VisitBookingSearchResults",
            // });
            this.$router.push({ name: "VisitBookingDetails" });
          } else {
            this.$router.push({
              name: "VisitBookingSearchResults",
            });
          }
        } else {
          this.updateResult({
            show: true,
            success: false,
            title: searchResponse.data.errorMessage,
            message: window.$msg.noResultsFoundMsg,
          });
        }
      } else {
        this.updateResult({
          show: true,
          success: false,
          title: searchResponse,
        });
      }
    },
    formatDate(dateString) {
      return formatters.formatDate(dateString);
    },
    beforeRouteLeave(to, from, next) {
      //Cause the back button to close any popups instead of navigate to another page

      const inputs = [
        this.inputPopupSelectBranch,
        this.inputPopupSelectPax,
        this.inputPopupSelectDate,
        this.inputPopupSelectTime,
        this.inputPopupSelectDuration,
      ];

      for (const i of inputs) {
        if (i != null && i.show) {
          i.show = false;

          return true;
        }
      }

      return false;
    },
  },
  watch: {
    settings: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue) {
          let selectedBranch = this.visitBranchMenus[0];

          if (this.onsiteMode) {
            const branch = this.visitBranchMenus.find(
              (x) => x.id === this.mode.branchId
            );

            if (branch) {
              selectedBranch = branch;
            }
          }

          this.inputPopupSelectBranch.selectedItem = selectedBranch;
        }
      },
    },
    paxList: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue.length) {
          const paxList = newValue.map((x) => x.name);

          if (!paxList.includes(this.selectedPax.name)) {
            this.inputPopupSelectPax.selectedItem = newValue[0];
          }
        }
      },
    },
    calendar: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          //Mainly used for the initial update, and to auto-update calandar to tomorrow when there is no timeslots left for today
          if (this.inputPopupSelectDate.selectedItem) {
            const isTodaySelected = validators.isToday(
              this.inputPopupSelectDate.selectedItem,
              this.time.nowMoment
            );

            const isBranchOpenToday = validators.isBranchOpenToday(
              this.inputPopupSelectDate.selectedItem,
              this.selectedBranch.openingDaysOfWeek,
              this.settings.holidays,
              this.selectedBranch.code
            );

            if (isTodaySelected || !isBranchOpenToday) {
              this.inputPopupSelectDate.selectedItem = newValue.min;
            }
          } else {
            this.inputPopupSelectDate.selectedItem = newValue.min;
          }
        }
      },
    },
    timeList: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue.length) {
          const timeNameList = newValue.map((x) => x.name);

          if (
            !this.selectedTime.name ||
            !timeNameList.includes(this.selectedTime.name)
          ) {
            this.inputPopupSelectTime.selectedItem = newValue[0];
          }
        }
      },
    },
    durationList: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue.length) {
          const durationList = newValue.map((x) => x.name);

          if (
            !this.selectedDuration.name ||
            !durationList.includes(this.selectedDuration.name)
          ) {
            this.inputPopupSelectDuration.selectedItem = newValue[0];
          }
        }
      },
    },
  },
};
</script>

<style scoped>
.label {
  font-weight: bold;
  font-size: 14px;
}

.button-group {
  margin: 6px;
}

.button-group .col {
  margin: 5px;
  padding: 0px;
}

.v-list-item__content {
  padding: 0;
}

.inputPopupSelectDiv {
  margin-bottom: 24px;
}
</style>
